/**
 * Route for `appmetrica-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AppmetricaIntegrationPage } from "../features/appmetrica-integration/AppmetricaIntegrationPage";

export const appmetricaIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/appmetrica-integration",
	component: AppmetricaIntegrationPage,
});

export default appmetricaIntegrationRoute;
